// extracted by mini-css-extract-plugin
export default {"download":"FlowDownload_download__CGrW3","is-disabled":"FlowDownload_is-disabled__8ScJQ"};